import { WageFrequency } from "@api/shared-runtime/enums";

export const wageFrequencyToEnding = {
  [WageFrequency.OneTime]: "/shift",
  [WageFrequency.Hourly]: "/hr",
  [WageFrequency.Daily]: "/day",
  [WageFrequency.Weekly]: "/week",
  [WageFrequency.Monthly]: "/month",
  [WageFrequency.Yearly]: "/yr",
};
